<ng-container *ngIf="(isRunning$ | async) === false; else loading">
  Wachtrij: {{ queueSize$ | async }} items
</ng-container>
<ng-template #loading>
  <img class="loader" src="assets/img/loader-primary.svg" />
</ng-template>
